var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafariPinnedTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "700pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 700 700",
    width: "700pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2625 6125v-875h875 875v873 872l-875 3-875 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1750v-1750h3500 3500v1750 1750h-875-875v-875-875h-1750-1750v875 875h-875-875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariPinnedTab);
export default __webpack_public_path__ + "static/media/safari-pinned-tab.72bc0a8dfc658ce28eb4cba6885eadf1.svg";
export { ForwardRef as ReactComponent };